(function () {
    'use strict';

    angular
        .module('FormBuilder')
        .directive('fbBindHtmlCompile', fbBindHtmlCompile);

    function fbBindHtmlCompile() {
        return {
            restrict: 'E',
            controller: fbBindHtmlCompileCtrl,
            controllerAs: 'vm',
            bindToController: true,
            scope: {
                template: '=',
                options: '=?',
                data: '=?',
                getModel: '=?'
            }
        };
    }

    function fbBindHtmlCompileCtrl($compile, $element, $scope) {
        var vm = this;
        var cloneElement = null;
        this.$onInit = function() {
            if (!vm.data) vm.data = {};

            $scope.$watch(function() {return vm.template; }, function() {
                if (cloneElement) { cloneElement.off(); }
                $element.html(vm.template);
                cloneElement = $compile($element.contents())($scope);
            });

            $scope.$on('$destroy', function() {
                cloneElement.off();
            });
        }
    }
})();